import {
  FiGrid,
  FiUsers,
  FiUser,
  FiCompass,
  FiSettings,
  FiSlack,
  FiGlobe,
  FiTarget,
  FiBookOpen,
  FiXOctagon,
  FiActivity,
  FiCodepen,
  FiArchive,
  FiArrowUp,
  FiArrowUpCircle,
  FiAperture,
  FiFile,
  FiPackage
} from "react-icons/fi";
import routes from "routes";

/**
 * ⚠ These are used just to render the Sidebar!
 * You can include any link here, local or external.
 *
 * If you're looking to actual Router routes, go to
 * `routes/index.js`
 */
const sidebar = [
  {
    path: "/dashboard", // the url
    icon: FiGrid, // icon
    name: "Dashboard", // name that appear in Sidebar
  },
  {
    path: "/services",
    icon: FiCompass,
    name: "Services",
    previleges: ["view_service", "view_any_service","create_service","update_service","delete_service"],

  },
  {
    icon: FiAperture,
    path: "/references",
    name: "References",
    previleges: ["view_reference", "view_any_reference","create_reference","update_reference","delete_reference"],
  },
    {
    icon: FiArchive,
    path: "/categories",
    name: "ProjectCategories",
    previleges: ["view_category", "view_any_category","create_category","update_category","delete_category"],

  },
  {
    icon: FiSlack,
    name: "Projects",
    path: "/projects",
    previleges: ["view_project", "view_any_project","create_project","update_project","delete_project"],

  },
  {
    path: "/blogs",
    icon: FiBookOpen,
    name: "Blogs",
    previleges: ["view_blog", "view_any_blog","create_blog","update_blog","delete_blog"],
  },
  {
    icon: FiCodepen,
    path: "/careers",
    name: "Careers",
    previleges: ["view_career", "view_any_career","create_career","update_career","delete_career"],

  },


  

  // {
  //   icon: FiPackage,
  //   name: "Departments",
  //   path: "/departments",
  //   previleges: ["view_department", "view_any_department","create_department","update_department","delete_department"],

  // },
  {
    path: "/contacts",
    icon: FiUsers,
    name: "Contacts",
    previleges: ["view_contact", "view_any_contact","create_contact","update_contact","delete_contact"],
  },
  
  {
    path: "/quotes",
    icon: FiFile,
    name: "QuoteRequests",
    previleges: ["view_quote", "view_any_quote","create_quote","update_quote","delete_quote","reply_quotes"],
  },
  {
    path: "/quotes-management",
    icon: FiFile,
    name: "Quotes",
    previleges: ["quotes_management"],
  },
  {
    icon: FiUsers,
    name: "Users",
    path: "/users",
    previleges: ["view_user", "view_any_user"],
  },
  {
    icon: FiActivity,
    name: "Subscribers",
    path: "/subscribers",
    previleges: ["view_subscriber", "view_any_subscriber", "delete_subscriber", "send_email_subscribers"],

  },{
    icon: FiUser,
    name: "Admins",
    path: "/our-staff",
    previleges: ["view_admin", "view_any_admin","create_admin","update_admin","delete_admin"],
  },
  {
    icon: FiGlobe,
    name: "WebsiteManager",
    previleges: ["view_history","view_detail","update_detail", "update","view_any_home_slider","create_home_slider","update_home_slider","view_home_slider","delete_home_slider"],

    routes: [
      // {
      //   path: "/languages",
      //   name: "Languages",
      // },
      {
        path: "/sliders",
        name: "SliderManagement",
        previleges: ["view_any_home_slider","create_home_slider","update_home_slider","view_home_slider","delete_home_slider"],
      },
      // {
      //   path: "/counts",
      //   name: "CountsManagement",
      // },
      {
        path: "/details",
        name: "OurDetails",
        previleges: ["view_detail","update_detail", "update"],

      },
      {
        path: "/history",
        name: "OurHistory",
        previleges: ["view_history"],
      },
    ],
  },
];

export default sidebar;
